import React from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, Button, Avatar, Radio, Input } from 'antd';

const FormNewService = ({ onSubmit, isSaving, isSavedServices, fileIcons }) => {

    const [form] = Form.useForm();

    const onReset = () => {
        form.resetFields();
    }

    return (
        <Grid>
            <Form onFinish={onSubmit} form={form} initialValues={{
                field_icon: fileIcons && fileIcons[0].name
            }}>
                <Row center="xs">
                    <Col xs={10} sm={8} md={4}>
                        <Form.Item name="field_service" rules={[{ required: true, message: 'Por favor, complete con nombre del nuevo servicio', }]}>
                            <Input placeholder="Servicio"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col>
                        <Form.Item name="field_icon" rules={[{ required: true, message: 'Por favor, seleccione un icono para el nuevo servicio'}]}>
                            <Radio.Group name="radiogroup">
                                {fileIcons && fileIcons.map((icon, index) => <Radio key={index} value={icon.name}><Avatar size={32} src={icon.url} /></Radio>)}
                            </Radio.Group>
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={12}>
                        <Form.Item>
                            {
                                isSaving ?
                                    <Button type="primary" htmlType="submit" disabled={true} loading>
                                        Guardando
                                    </Button>
                                    :
                                    <Button type="primary" htmlType="submit">
                                        Guardar
                                    </Button>
                            }
                        </Form.Item>
                    </Col>
                </Row>
                {
                    isSavedServices && onReset()
                }
            </Form>
        </Grid>
    );
};

FormNewService.propTypes = {
    
};

export default FormNewService;